export default {
   	showAddNewCandidateModel: false,
   	showViewCandidate: false,
 
	candidateViewId:null,
	candidateDelete: null,
	candidateList:[],
	
}